import { Divider, Paper, Skeleton, Typography } from '@/ui';

import type { FC } from 'react';

interface MemberInsightsSkeletonProps {
  centered?: boolean;
  heading: string;
}

const rowCount = 2;

const PanelSkeleton: FC = () => (
  <Paper className="shadow-elevation-1 rounded-xl border border-cement-300 p-6">
    <Skeleton animation="wave" className="mb-4 size-12" variant="circular" />
    <Skeleton animation="wave" className="mb-2 h-8 w-40" variant="rounded" />
    <Skeleton animation="wave" className="h-5 w-full" variant="text" />
    <Skeleton animation="wave" className="mb-4 h-5 w-3/4" variant="text" />
    <Divider className="mb-4" />
    {Array.from({ length: rowCount }, (_, index) => (
      <div
        // Static placeholder rows, order never changes.

        key={index}
        className="flex items-center justify-between gap-4 py-3"
      >
        <div className="space-y-1">
          <Skeleton animation="wave" className="h-5 w-32" variant="text" />
          <Skeleton animation="wave" className="h-4 w-48" variant="text" />
        </div>
        <Skeleton animation="wave" className="h-8 w-20" variant="rounded" />
      </div>
    ))}
  </Paper>
);

// Placeholder shown while the Insights data loads. Mirrors the real page layout so
// nothing jumps when the panels arrive.
const MemberInsightsSkeleton: FC<MemberInsightsSkeletonProps> = ({
  centered = false,
  heading,
}) => (
  <div
    aria-busy="true"
    className={
      centered
        ? 'mx-auto w-full max-w-[1020px] px-4 pb-4 pt-12'
        : 'container mx-auto max-w-screen-lg px-4 pb-4 pt-12'
    }
    data-testid="member-insights-skeleton"
  >
    <Typography className="mb-6" variant="h4">
      {heading}
    </Typography>
    <div className="grid w-full max-w-[1020px] grid-cols-1 items-start gap-6 lg:grid-cols-2">
      <PanelSkeleton />
      <PanelSkeleton />
    </div>
  </div>
);

export default MemberInsightsSkeleton;
